import { IncomeStatus } from "shared/types";
import { toMoney } from "shared/utils";
import { Stat } from "views/applications-id-report/components/Stat";
import { mapIncomeSourceStatus } from "views/applications-id-report/slices/CombinedIncomeReportSlice/helpers";
import { CombinedIncome } from "views/applications-id-report/slices/CombinedIncomeReportSlice/types/income";
import { VerifiedItem } from "views/applications-id-report/slices/CombinedIncomeReportSlice/types/verified";
import {
  getIncomeActualNetAndGrossDollars,
  getMonthlyAmount
} from "views/applications-id-report/slices/CombinedIncomeReportSlice/utils";

export const IncomeStats = ({
  income,
  currentItem,
  isIncomeIncomplete
}: {
  income: CombinedIncome;
  currentItem?: VerifiedItem | VerifiedItem[];
  isIncomeIncomplete?: boolean;
}) => {
  const { status } = mapIncomeSourceStatus(income);
  const isRejected = status === "Rejected";
  const isProcessing = [IncomeStatus.Processing, IncomeStatus.Pending].includes(
    income.status
  );
  const { actualVerifiedNetMonthlyDollars, actualVerifiedGrossMonthlyDollars } =
    !isIncomeIncomplete
      ? getIncomeActualNetAndGrossDollars(income as CombinedIncome, currentItem)
      : {};

  const selfReportedIncomeCents = income.amount_cents ?? 0;

  return (
    <div className="flex items-start">
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 flex-1">
        <Stat
          title="Verified gross monthly"
          valueClassName="!text-2xl"
          value={
            (isRejected && !actualVerifiedGrossMonthlyDollars) || isProcessing
              ? "-"
              : toMoney(actualVerifiedGrossMonthlyDollars ?? 0)
          }
        />
        <Stat
          title="Verified net monthly"
          valueClassName="!text-2xl"
          value={
            (isRejected && !actualVerifiedNetMonthlyDollars) || isProcessing
              ? "-"
              : toMoney(actualVerifiedNetMonthlyDollars ?? 0)
          }
        />
        <Stat
          title="Self-reported gross monthly"
          valueClassName="!text-2xl"
          value={toMoney(
            getMonthlyAmount(selfReportedIncomeCents ?? 0, income.pay_period) /
              100
          )}
        />
      </div>
    </div>
  );
};
